import { Option } from './types';

export const options: Option[] = [5, 10, 25, 50, 100].map((number) => ({
  label: `${number} users`,
  value: number,
}));
